// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".height-200{height:200px}.code-editor{background:#f5f5f5;color:#2d2d2d;font-family:Fira code,Fira Mono,Consolas,Menlo,Courier,monospace;font-size:14px;line-height:1.5;padding:5px}.prism-editor__textarea:focus{outline:none}.prism-editor-wrapper textarea{max-height:none!important;font-family:Fira code,Fira Mono,Consolas,Menlo,Courier,monospace!important}", ""]);
// Exports
module.exports = exports;
